const config = {
  oldUrl: 'https://happy.ly/',
  url: 'https://app.happyly.com/',
}

export default config
